import React, { useRef, useState } from 'react';
import image from '../images/laroye_cream.png';
import { Link } from 'react-router-dom';
import '../styles/nav.css'; // Import your CSS file 

const NavBar = () => {
  const navRef = useRef();
const [hiddenMenu,SetHiddenMenu] = useState(true);

  const handleClick = () => {
    // Scroll to Section 1 on link click
    const section1 = document.getElementById('cards');
    if (section1) {
      section1.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    
    <div className="navbar">

      <nav  ref={navRef} style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: 'black', padding: '10px', color: '#fff' }}>
        <div>
          <Link to="/"><img src={image} style={{ margin: '10px', marginBottom: '-10px' }} height='45px' maxWidth='160px' alt="joyfuel" /></Link>
        </div>
        <div className='topnav' style={{ fontSize: "23px", display: 'flex' }}>
          <a className={`nav ${hiddenMenu?'hidden':''}`} href="about" >ABOUT</a>
          <Link className={`nav ${hiddenMenu?'hidden':''}`}  to="/#cards"  onClick={handleClick}>APP FEATURES</Link>
          <a className={`nav ${hiddenMenu?'hidden':''}`}  href="#contact">CONTACT</a>
<a className={`nav ${hiddenMenu?'hidden':''} tio border`}  href="tryitout">TRY IT OUT!</a>
          
          {/* <a className=" nav-btn" href="tryitout" onClick={showNavBar} style={navLinkStyle}><FaBars /></a> */}
        </div>
       
        <span className="nav-btn" onClick={()=>SetHiddenMenu(!hiddenMenu)}>|||</span>
      </nav>
    </div>
  )
}

// const navLinkStyle = {
//   color: '#f3e3d1',
//   textDecoration: 'none',

//   margin: '0 15px',
//   padding: '5px 10px',

//   transition: 'background-color 0.3s',
// };



export default NavBar;
 